/** Audit actions. Stored as text; add new ones as modules ship. */
export const AUDIT_ACTIONS = {
  "auth.sign_in": "Signed in",
  "auth.sign_in_failed": "Failed sign-in",
  "auth.sign_out": "Signed out",
  "auth.session_expired": "Session expired",
  "auth.session_ended": "Ended a session",
  "user.invited": "Added user",
  "user.updated": "Updated user",
  "user.deactivated": "Deactivated user",
  "user.reactivated": "Reactivated user",
  "user.roles_changed": "Changed user roles",
  "user.override_changed": "Changed permission override",
  "user.notifications_changed": "Changed someone's notifications",
  "role.created": "Created role",
  "role.updated": "Updated role",
  "role.deleted": "Deleted role",
  "settings.updated": "Updated settings",
  "quickbooks.linked": "Linked records to QuickBooks",
  "quickbooks.invoices": "Checked invoices and payments against QuickBooks",
  "quickbooks.expenses": "Brought in expenses from QuickBooks",
  "quickbooks.changes": "Applied changes made in QuickBooks",
  "sync.applied": "Applied a sync (JobNimbus and QuickBooks)",
  "workflow.created": "Created workflow",
  "workflow.updated": "Updated workflow",
  "workflow.archived": "Archived workflow",
  // Customers became contacts; these stay so older history still reads well.
  "customer.created": "Added customer",
  "customer.updated": "Updated customer",
  "customer.deleted": "Deleted customer",
  "customer.restored": "Restored customer",
  "contact.created": "Added contact",
  "contact.updated": "Updated contact",
  "contact.deleted": "Deleted contact",
  "contact.restored": "Restored contact",
  "contact.merged": "Merged a duplicate contact into this one",
  "contact.paperwork_imported": "Brought in paperwork from JobNimbus",
  "contact.linked": "Linked related contact",
  "contact.unlinked": "Removed related contact",
  "contact_type.created": "Added contact type",
  "contact_type.updated": "Updated contact type",
  "contact_type.deleted": "Deleted contact type",
  "job.created": "Added job",
  "job.updated": "Updated job",
  "job.stage_changed": "Moved job",
  "job.deleted": "Deleted job",
  "job.restored": "Restored job",
  "note.created": "Added note",
  "note.updated": "Edited note",
  "note.deleted": "Deleted note",
  "note.restored": "Restored note",
  "lead.received": "Website lead received",
  "file.uploaded": "Added file",
  "file.updated": "Updated file",
  "file.deleted": "Deleted file",
  "file.restored": "Restored file",
  "file.shared": "Made a share link for a file",
  "report.shared": "Made a share link for a report",
  "job.qb_renamed": "Renamed the job in QuickBooks",
  "file.linked": "Linked a Google Drive file",
  "file.unlinked": "Removed a Google Drive link",
  "file.unshared": "Turned off a file's share links",
  "task.created": "Added task",
  "task.updated": "Updated task",
  "task.completed": "Completed task",
  "task.reopened": "Reopened task",
  "task.deleted": "Deleted task",
  "appointment.created": "Scheduled appointment",
  "appointment.updated": "Changed appointment",
  "appointment.deleted": "Canceled appointment",
  "proposal.created": "Started proposal",
  "proposal.read": "Read carrier estimate",
  "proposal.read_failed": "Couldn't read carrier estimate",
  "proposal.sent": "Sent proposal",
  "proposal.viewed": "Customer opened proposal",
  "proposal.signed": "Customer signed proposal",
  "proposal.declined": "Customer declined proposal",
  "proposal.voided": "Voided proposal",
  "proposal.deleted": "Deleted proposal",
  "proposal.restored": "Restored proposal",
  "workorder.created": "Added work order",
  "workorder.updated": "Changed work order",
  "workorder.sent": "Sent work order",
  "workorder.compliance_override": "Sent work order despite missing paperwork",
  "workorder.viewed": "Sub opened work order",
  "workorder.confirmed": "Sub confirmed work order",
  "workorder.declined": "Sub declined work order",
  "workorder.proposed": "Sub proposed a new time",
  "workorder.accepted_time": "Accepted the sub's new time",
  "workorder.completed": "Completed work order",
  "workorder.canceled": "Canceled work order",
  "workorder.deleted": "Deleted work order",
  "compliance.updated": "Updated subcontractor paperwork",
  "insurance.reminded": "Emailed an insurance reminder",
  "laboritem.changed": "Changed labor price list",
  "comm.sent": "Sent text",
  "email.sent": "Emailed",
  "rivian.sent": "Sent an address to the Rivian",
  "quickbooks.job_early": "Created the job in QuickBooks early (for a receipt)",
  "comm.linked": "Linked a number to a contact",
  "comm.lead_created": "Made a lead from a call or text",
  "file.downloaded": "Downloaded files as a zip",
  "subportal.link": "Made a portal link for a sub",
  "subportal.revoked": "Turned off a sub's portal link",
  "receipt.submitted": "Turned in receipt",
  "receipt.added": "Drafted a sub's bill from their work order",
  "receipt.updated": "Changed receipt",
  "receipt.ready": "Marked receipt ready",
  "receipt.compliance_override": "Marked a sub's bill ready despite missing paperwork",
  "receipt.approved": "Approved receipt",
  "receipt.reopened": "Sent receipt back for changes",
  "receipt.deleted": "Deleted receipt",
  "receipt.voided": "Voided receipt (deleted in QuickBooks)",
  "receipt.discount_lapsed": "Early-pay discount missed",
  "comms.blocked": "Blocked a phone number",
  "comms.unblocked": "Unblocked a phone number",
  "receipt.split": "Split a file into several receipts",
  "invoice.created": "Added invoice",
  "invoice.updated": "Changed invoice",
  "invoice.sent": "Sent invoice",
  "invoice.new_link": "Replaced invoice pay link",
  "invoice.card_over_limit_on": "Allowed card payment over the limit on an invoice",
  "invoice.card_over_limit_off": "Stopped allowing card payment over the limit on an invoice",
  "invoice.voided": "Voided invoice",
  "statement.created": "Made a statement",
  "statement.voided": "Voided a statement",
  "payment.recorded": "Recorded payment",
  "payment.online": "Customer paid online",
  "payment.failed": "Online payment failed",
  "payment.deleted": "Removed payment",
  "permit.created": "Added permit",
  "permit.updated": "Changed permit",
  "permit.deleted": "Removed permit",
  "inspection.created": "Scheduled inspection",
  "inspection.updated": "Updated inspection",
  "warranty.created": "Started warranty",
  "warranty.updated": "Changed warranty",
  "warranty.claim": "Warranty claim",
  "changeorder.created": "Added change order",
  "changeorder.updated": "Changed change order",
  "changeorder.sent": "Sent change order to sign",
  "changeorder.approved": "Approved change order",
  "changeorder.signed": "Customer signed change order",
  "changeorder.declined": "Customer declined change order",
  "changeorder.voided": "Voided change order",
  "automation.created": "Added automation",
  "automation.updated": "Changed automation",
  "automation.deleted": "Deleted automation",
  "survey.answered": "Customer answered the survey",
  "user.signature": "Changed their signature",
  "completion.created": "Started completion package",
  "completion.issued": "Issued certificate of completion and invoice summary",
  // Before Oct 2026 the homeowner signed the certificate; kept for those entries.
  "completion.sent": "Sent certificate of completion to sign",
  "completion.signed": "Homeowner signed certificate of completion",
  "completion.depreciation": "Marked depreciation received",
  "measurement.added": "Added measurement report",
  "measurement.removed": "Removed measurement report",
  "materialorder.created": "Started material order",
  "materialorder.ordered": "Placed material order",
  "materialorder.delivered": "Materials delivered",
  "materialorder.cancelled": "Cancelled material order",
  "materialorder.abc_reset": "Checked ABC: material order not there, may send again",
  "import.pulled": "Pulled records to import",
  "import.committed": "Imported records",
  "import.files": "Started copying files from JobNimbus",
  "import.invoices": "Brought in invoices, payments, and estimates from JobNimbus",
  "import.reset": "Removed everything imported from JobNimbus (start over)",
  "testing.reset": "Reset all data (testing)",
  "testing.fresh_start": "Fresh start: everything reset to a new install (testing)",
} as const;

export type AuditAction = keyof typeof AUDIT_ACTIONS;
